const React = require('react');
const isNode = (typeof process !== 'undefined');
const Select = isNode ? require('react-select') : <div/>;
const Input = require('./../../FormComponents/Input');

class Bod extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            rentPeriod: {value: null, label: null}
        };

        this.setRentPeriod = this.setRentPeriod.bind(this);
    }
    getValues() {
        return {
            address: this.address.value,
            identityNumber: this.identityNumber.value,
            fromDate: this.fromDate.value,
            b10Ort84: this.state.b10Ort84,
            rentPeriod: this.state.rentPeriod.label,
            creditCheck: this.state.creditCheck,
            comment: this.comment.value
        }
    }
    setRentPeriod(option) {
        this.setState({rentPeriod: option});
    }
    render() {
        const {hideHeaders, color} = this.props;
        // Rent period
        const selectedRentPeriod = this.state.rentPeriod && this.state.rentPeriod.value;
        const rentPeriodOptions = [
            {value: 'langtidsleie', label: 'Langtidsleie'},
            {value: 'korttidsleie', label: 'Korttidsleie'}
        ];

        return (
        <div className={`forms__inputContainer forms__inputContainer--${color}`}>
            {!hideHeaders && <h2 className="forms__formHeader">Søknad om bod</h2>}
            <div className="forms__formElement">
                <Input name="address" type="text" validations="minLength:1" required placeholder="Adresse" ref={(address) => this.address = address}/>
            </div>
            <div className="forms__formElement">
                <Input name="identityNumber" type="text" validations="minLength:1" required placeholder="Fødselsnummer" ref={(identityNumber) => this.identityNumber = identityNumber}/>
            </div>
            <div className="forms__formElement">
                <Input name="fromDate" type="text" placeholder="Ønsker å leie fra" ref={(fromDate) => this.fromDate = fromDate}/>
            </div>
            <div className="forms__formElement">
                <label><input type="checkbox" value={true} onChange={ev => this.setState({b10Ort84: ev.target.checked})}/> Jeg er beboer i B10 eller T84</label>
            </div>
            <div className="forms__formElement">
                <Select value={selectedRentPeriod} onChange={this.setRentPeriod} name="rentPeriod" options={rentPeriodOptions} className="react-select-custom" placeholder="Leietid"/>
            </div>
            <div className="forms__formElement">
                <label><input required type="checkbox" value={true} onChange={ev => this.setState({creditCheck: ev.target.checked})}/> Jeg samtykker til kredittsjekk</label>
            </div>
            <div className="forms__formElement">
                <label className="form-label">Andre kommentarer</label>
                <textarea placeholder="Andre kommentarer" ref={(comment) => this.comment = comment}/>
            </div>
        </div>
        )
    }
}

module.exports = Bod;



// WEBPACK FOOTER //
// ./src/main/resources/site/parts/Forms/forms/Bod/index.jsx